import React, { useContext } from 'react';
import { AuthMessageProvider, TrustNetwork } from '@op/auth-components/trustnetwork';
import { Message, useMessageGetter } from '@messageformat/react';
import { Action } from '@op/opds.opux';
import { ErrorCode } from '../constants';
import { StateContext } from '../State';
import { ModelContext } from '../ModelContext';

const onError = async (err) => {
    console.debug('trustnetwork onError called:', err);
    return 'error';
};

const onProviderData = async (data) => {
    console.debug('trustnetwork onProviderData called:', data);
};

const TrustNetworkLogin = (props) => {
    const state = useContext(StateContext);
    const messages = state.messages;
    const msg = useMessageGetter('fp');
    const { model } = useContext(ModelContext);
    return (
        <div id='trustnetwork-container'>
            <div id='auth-section-divider'>
                <div id='auth-section-divider-wrapper'>
                    <div id='auth-section-divider-text'>
                        <Message id='fp.authSectionDivider' />
                    </div>
                </div>
            </div>
            <section>
                <header className='opux-v6__opds'>
                    <h2>
                        <Message id='fp.trustnetwork.title' />
                    </h2>
                    <p>
                        <Message id='fp.trustnetwork.privacyText' />{' '}
                        <Action href={msg('trustnetwork.privacyLinkTarget')} external>
                            <Message id='fp.trustnetwork.privacyLinkText' />
                        </Action>
                    </p>
                </header>
                <AuthMessageProvider locale={state.lang} messages={messages}>
                    <TrustNetwork
                        gridOnly={true}
                        onError={onError}
                        onProviderData={onProviderData}
                        successUrl={model.tupasSuccessUrl}
                        cancelUrl={window.location.pathname + window.location.search + '#error/' + ErrorCode.TRUSTNETWORK_CANCEL}
                        imgRoot='/static/op/opux-static/v3/img'
                        overrides={{
                            aktia: {
                                image: 'tupas/aktia.svg',
                            },
                            danske: {
                                image: 'tupas/danske.png',
                            },
                            nordea: {
                                image: 'tupas/nordea.png',
                            },
                            saasto: {
                                image: 'tupas/saastopankki.png',
                            },
                        }}
                        origin={window.location.protocol + '//' + window.location.hostname}
                    />
                </AuthMessageProvider>
            </section>
        </div>
    );
};

export default TrustNetworkLogin;
